import { render, staticRenderFns } from "./ProcessOutputEvents.vue?vue&type=template&id=0a8d7554&scoped=true"
import script from "./ProcessOutputEvents.vue?vue&type=script&lang=js"
export * from "./ProcessOutputEvents.vue?vue&type=script&lang=js"
import style0 from "./ProcessOutputEvents.vue?vue&type=style&index=0&id=0a8d7554&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8d7554",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a8d7554')) {
      api.createRecord('0a8d7554', component.options)
    } else {
      api.reload('0a8d7554', component.options)
    }
    module.hot.accept("./ProcessOutputEvents.vue?vue&type=template&id=0a8d7554&scoped=true", function () {
      api.rerender('0a8d7554', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inventory/ProcessOutputEvents.vue"
export default component.exports